/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { SystemInfo } from 'crimson/lib/system-info-service/system-info.models';

@Injectable()
export class SystemInfoPluginConfig {
    systemInfoOverrideConfig: SystemInfoOverrideConfig;
}

export interface SystemInfoOverrideConfig {
    /**
     * An allow-list containing OS's that support SystemInfo override.
     */
    allowedOSs: string[];
    override: SystemInfo;
}
